import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import classnames from "classnames";
import DownArrow from "static/svg/arrow-down.svg";
import { StyledDropdown } from "./dropdown.scss";
import PictureComponent from "components/core/picture/picture-component";
import { RemoveIcon } from "./remove-icon";
const Dropdown = ({ items, selectedItem, itemRenderer, title, dropdownTitle, reset })=>{
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const handleDropdownButtonKeyPress = (event)=>event.key === "Enter" && toggleDropdown();
    const toggleDropdown = ()=>setIsDropdownOpen((isOpen)=>!isOpen);
    return /*#__PURE__*/ _jsxs(StyledDropdown, {
        className: classnames("dropdown", {
            "is-active": isDropdownOpen
        }),
        onMouseEnter: ()=>setIsDropdownOpen(true),
        onMouseLeave: ()=>setIsDropdownOpen(false),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classnames("dropdown-trigger", {
                    "has-selection": !!selectedItem
                }),
                children: /*#__PURE__*/ _jsxs("button", {
                    className: "dropdown-menu-button",
                    "aria-haspopup": "listbox",
                    "aria-controls": "dropdown-menu",
                    onKeyPress: handleDropdownButtonKeyPress,
                    children: [
                        !selectedItem ? /*#__PURE__*/ _jsx("span", {
                            className: "title",
                            children: title
                        }) : /*#__PURE__*/ _jsxs("span", {
                            className: "selected-item",
                            children: [
                                (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.icon) && /*#__PURE__*/ _jsx(PictureComponent, {
                                    src: selectedItem.icon,
                                    isDecorative: true
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text",
                                    children: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name
                                })
                            ]
                        }),
                        !!selectedItem ? /*#__PURE__*/ _jsx("span", {
                            className: "remove-icon",
                            onClick: reset,
                            children: /*#__PURE__*/ _jsx(RemoveIcon, {})
                        }) : /*#__PURE__*/ _jsx("span", {
                            className: "dropdown-icon",
                            children: /*#__PURE__*/ _jsx(DownArrow, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("dropdown-menu", {
                    "is-active": isDropdownOpen
                }),
                role: "menu",
                "aria-expanded": isDropdownOpen,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "dropdown-content",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "dropdown-title",
                            children: dropdownTitle
                        }),
                        items === null || items === void 0 ? void 0 : items.map(itemRenderer)
                    ]
                })
            })
        ]
    });
};
export default Dropdown;
